
import { Vue, Component, Prop } from 'vue-property-decorator';
import SmallCalendar from '@/features/dashboard/components/widgets/scheduledPickups/SmallCalendar.vue';
import { PickupStatus, ScheduledPickupItem } from '@/features/schedule-pickup/types';
import { useFormatTimestamp } from '@/features/common/helpers';
import { getCountryNameFromCode } from '@/features/shipment/helpers/createShipment';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';
import HistoryItemDetails from './HistoryItemDetails.vue';

@Component({
  components: {
    SmallCalendar,
    HistoryItemDetails,
  },
})
export default class HistoryItem extends Vue {
  @Prop({ required: true }) pickup!: ScheduledPickupItem;

  @Prop({ required: false, default: false }) isHighlight!: boolean;

  get displayCarrierCode(): string {
    return getDisplayCarrierCode(this.pickup.carrierCode, this.pickup.selectedService || '');
  }

  private showExpand = false;

  private useFormatTimestamp = useFormatTimestamp;

  private getCountryNameFromCode = getCountryNameFromCode;

  get fromCountryName(): string {
    if (!this.pickup.fromAddress.countryCode) return '';
    return this.getCountryNameFromCode(this.pickup.fromAddress.countryCode);
  }

  get isCancelled(): boolean {
    return this.pickup.status === PickupStatus.Cancelled;
  }

  get formattedFromAddress(): {line1: string, line2: string} {
    const {
      fromAddress,
    } = this.pickup;

    const line1 = `${fromAddress.contact}, ${fromAddress.company}`;

    const line2Part1 = `${fromAddress.addr1}${fromAddress.addr2 ? `, ${fromAddress.addr2}` : ''}`;
    const line2Part2 = `${fromAddress.city}, ${fromAddress.province}, ${fromAddress.postalCode}, ${this.fromCountryName}`;
    const line2 = `${line2Part1}, ${line2Part2}`;

    return { line1, line2 };
  }
}
